import {
  faArrowUp,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faColumns,
  faFilter,
  faPen,
  faPlus,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTimes,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LayersClearIcon from '@mui/icons-material/LayersClear'

import { VpnKey } from '@mui/icons-material'
import intl from 'localization/components'

export const localization = (messages) => {
  return {
    pagination: {
      firstAriaLabel: messages[intl.generic('first-page')],
      firstTooltip: messages[intl.generic('first-page')],
      previousAriaLabel: messages[intl.generic('previous-page')],
      previousTooltip: messages[intl.generic('previous-page')],
      nextAriaLabel: messages[intl.generic('next-page')],
      nextTooltip: messages[intl.generic('next-page')],
      lastAriaLabel: messages[intl.generic('last-page')],
      lastTooltip: messages[intl.generic('last-page')],
      labelRowsSelect: messages[intl.generic('rows')],
    },
    toolbar: {
      searchTooltip: messages[intl.searchBusiness('search-field')],
      searchPlaceholder: messages[intl.searchBusiness('search-field')],
    },
    header: {
      actions: messages[intl.generic('actions')],
    },
    body: {
      addTooltip: messages[intl.generic('add')],
      editTooltip: messages[intl.generic('edit')],
      deleteTooltip: messages[intl.riskMonitoringNew('delete-items')],
      editRow: {
        deleteText: messages[intl.settings('are-you-sure-delete-user')],
        cancelTooltip: messages[intl.confirmAction('cancel')],
        saveTooltip: messages[intl.confirmAction('confirm')],
      },
    },
  }
}

const CheckIcon = () => <FontAwesomeIcon icon={faCheck} />
const DetailPanelIcon = () => <FontAwesomeIcon icon={faChevronRight} />
const DeleteIcon = () => <FontAwesomeIcon icon={faTrash} />
const ExportIcon = () => <FontAwesomeIcon icon={faSave} />
const FilterIcon = () => <FontAwesomeIcon icon={faFilter} />
const FirstPageIcon = () => <FontAwesomeIcon icon={faStepBackward} />
const LastPageIcon = () => <FontAwesomeIcon icon={faStepForward} />
const NextPageIcon = () => <FontAwesomeIcon icon={faChevronRight} />
const PreviousPageIcon = () => <FontAwesomeIcon icon={faChevronLeft} />
const SearchIcon = () => <FontAwesomeIcon icon={faSearch} />
const ThirdStateCheckIcon = () => <FontAwesomeIcon icon={faTrash} />
const AddIcon = () => <FontAwesomeIcon icon={faPlus} />
const SortArrowIcon = ({ className }) => (
  <FontAwesomeIcon icon={faArrowUp} className={className} />
)
const ClearIcon = () => <FontAwesomeIcon icon={faTimes} />
const EditIcon = () => <FontAwesomeIcon icon={faPen} />
const ViewColumnIcon = () => <FontAwesomeIcon icon={faColumns} />
const DeleteApiIcon = () => <LayersClearIcon />
const UserApiToken = () => <VpnKey />

export const icons = {
  Check: CheckIcon,
  DetailPanel: DetailPanelIcon,
  Delete: DeleteIcon,
  Export: ExportIcon,
  Filter: FilterIcon,
  FirstPage: FirstPageIcon,
  LastPage: LastPageIcon,
  NextPage: NextPageIcon,
  PreviousPage: PreviousPageIcon,
  Search: SearchIcon,
  ThirdStateCheck: ThirdStateCheckIcon,
  Add: AddIcon,
  SortArrow: SortArrowIcon,
  Clear: ClearIcon,
  Edit: EditIcon,
  ViewColumn: ViewColumnIcon,
  DeleteApi: DeleteApiIcon,
  UserApiToken,
}
